import React from "react";

import HeroCarouselSlice from "../../components/slices/heroCarousel/HeroCarouselSlice";

const HeroCarousel = ({ slice }) => {
  return <HeroCarouselSlice slice={slice} />;
};

export default HeroCarousel;
